const ProjectFragment = `
fragment ProjectFragment on JiraProject {
  id
  projectId
  key
  uuid
  name
  avatar {
    medium
  }
  projectType
  projectStyle
  status
  created
}
`;

export const PROJECT_BY_KEY_QUERY = `
query jiraProjectByKey($projectKey: String!, $cloudId: ID!) {
  jira {
    jiraProjectByKey(key: $projectKey, cloudId: $cloudId) {
      ...ProjectFragment
    }
  }
}
${ProjectFragment}
`;

export const PROJECT_BY_ID_QUERY = `
query jiraProject($projectAri: ID!) {
  jira {
    jiraProject(id: $projectAri) {
      ...ProjectFragment
    }
  }
}
${ProjectFragment}
`;
